import LSelect from './LSelect.vue'

export default (Vue) => {
  Vue.component(LSelect.name, LSelect)
}
